// MainLayout.js
import React, { useState, useEffect, useRef } from "react";
import Sidebar from "./sidebar"; // Adjust the path if needed
import { Outlet, Navigate, useNavigate } from "react-router-dom";
import { ReactComponent as BellIcon0 } from "../img/bellicon0.svg";
import { ReactComponent as BellIcon1 } from "../img/bellicon1.svg";
import { instance2 } from "../utils/axiosInstance";
import { useLocation } from "react-router-dom";
import { usePwa } from "../utils/usePwa";

export default function MainLayout() {
  const [username, setUsername] = useState("");
  const [rolename, setRolename] = useState("");
  const [kitchenname, setKitchenname] = useState("");
  const [roleId, setRoleId] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [locationName, setLocationname] = useState("");
  const navigate = useNavigate();
  const dropdownRef = useRef(null); // Ref for dropdown
  const [notificationCount, setNotificationCount] = useState(0);
  //const [kitchenPackQty, setKitchenPack] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [isDropdownNotifOpen, setIsDropdownNotifOpen] = useState(false);
  const dropdownNotifRef = useRef(null); // Ref for dropdown
  const [loading, setLoading] = useState(false);
  const { canInstall, installPrompt } = usePwa();

  useEffect(() => {
    const storedUsername = localStorage.getItem("userAuthentication");
    setUsername(storedUsername);
    const storedRolename = localStorage.getItem("rolename");
    setRolename(storedRolename);
    const storedLocationname = localStorage.getItem("locationname");
    setLocationname(storedLocationname);
    const storedKitchenname = localStorage.getItem("kitchenname");
    setKitchenname(storedKitchenname);
    const storedRoleId = localStorage.getItem("roleid");
    setRoleId(storedRoleId);
  }, []);

  const roleIds = localStorage?.getItem("roleId") || null;
  const roleClass = localStorage
    ?.getItem("rolename")
    ?.substring(0, localStorage.getItem("rolename").length - 6)
    .toLowerCase();

  // console.log("roleee",roleClass, roleIds)

  useEffect(() => {
    // Fetch notification data from the API
    const fetchNotifications = async () => {
      try {
        const response = await instance2.get(
          `notification/count/${roleClass === "bgn" ? "central" : roleClass}/id/${roleIds}`,
        ); // Replace with your API endpoint
        const data = response.data;
        // console.log("new", data)
        // console.log("response", response)
        // console.log("newsss", data[0].new)

        if (response.status === "OK") {
          setNotificationCount(parseInt(data[0].new, 10)); // Parse the "new" field to an integer
          // console.log("count",notificationCount)
        }
      } catch (error) {
        //console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, [roleClass, roleIds]);

  const handleIconClick = async () => {
    setLoading(true); // Start the loading indicator
    if (!isDropdownNotifOpen) {
      // Fetch notifications only when opening the dropdown
      try {
        const response = await instance2.get(
          `notification/list/${roleClass}/id/${roleIds}`,
        ); // Replace with your API endpoint
        const data = response.data;
        // console.log("responsenotif", response);

        if (response.status === "OK") {
          setNotifications(data); // Set the fetched notifications
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false); // Stop the loading indicator
      }
    }

    // Toggle dropdown visibility
    setIsDropdownNotifOpen((prevState) => !prevState);
  };

  const handleOutsideClick = (event) => {
    // Check if the clicked element is outside the dropdown
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      !event.target.closest(".dropdown-trigger") // Prevent closing when clicking on the trigger
    ) {
      setIsDropdownOpen(false);
    }
  };

  const handleOutsideNotifClick = (event) => {
    // Check if the clicked element is outside the dropdown
    if (
      dropdownNotifRef.current &&
      !dropdownNotifRef.current.contains(event.target) &&
      !event.target.closest(".dropdown-trigger") // Prevent closing when clicking on the trigger
    ) {
      setIsDropdownNotifOpen(false);
    }
  };

  useEffect(() => {
    // Attach event listener for clicks
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      // Clean up event listener
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    // Attach event listener for clicks
    document.addEventListener("mousedown", handleOutsideNotifClick);
    return () => {
      // Clean up event listener
      document.removeEventListener("mousedown", handleOutsideNotifClick);
    };
  }, []);

  // Check if the user is authenticated
  const isAuthenticated = !!localStorage.getItem("ACCESS");

  const handleLogOut = () => {
    localStorage.removeItem("userAuthentication");
    localStorage.removeItem("userId");
    localStorage.removeItem("ACCESS");
    localStorage.removeItem("locationId");
    localStorage.removeItem("kitchenId");
    localStorage.removeItem("rolename");
    localStorage.removeItem("locationname");
    localStorage.removeItem("kitchenname");
    localStorage.removeItem("roleId");
    localStorage.removeItem("rolecode");
    localStorage.removeItem("name");
    localStorage.removeItem("language");

    navigate("/login", { replace: true });
  };

  const location = useLocation();
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    const queryParams = new URLSearchParams(location.search);
    const userfeedback = queryParams.get("userfeedback");
    const usercomplain = queryParams.get("usercomplain");

    // if (userfeedback||usercomplain){

    // }
    // else
    return <Navigate to="/login" replace />;
  }
  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex-1 overflow-auto bg-[#F1F2F3] relative">
        {/* Blurry Background */}
        <div className="absolute top-0 right-2 w-[20vw] h-[20vw] bg-red-100 opacity-50 blur-md rounded-full pointer-events-none rounded-tl-none rounded-tr-none rounded-br-none z-0"></div>

        {/* Header */}
        {/*absolute -top-3 -right-0 rounded-2xl px-6 py-3 z-30 w-[300px] max-w-[90%] flex justify-between items-center*/}
        <div className="absolute z-10 -top-3 -right-0">
          <div className="flex justify-end items-center pt-4 relative">
            {notificationCount === 0 ? (
              <BellIcon0
                className="mx-5 text-xs cursor-pointer"
                onClick={handleIconClick}
                ref={dropdownNotifRef} // Attach ref to the dropdown
              />
            ) : (
              <BellIcon1
                className="mx-5 text-xs cursor-pointer"
                onClick={handleIconClick}
                ref={dropdownNotifRef} // Attach ref to the dropdown
              />
            )}
            {/* Username with Dropdown */}

            <div
              className="relative cursor-pointer flex items-center gap-2 dropdown-trigger"
              onClick={() => setIsDropdownOpen((prev) => !prev)}
            >
              <div className="flex text-gray-700 font-semibold text-xxs flex-col">
                <div>{`Halo, ${username}`}</div>
                <div>{`${rolename}${
                  !kitchenname
                    ? locationName
                      ? `, ${locationName.toUpperCase()}`
                      : ""
                    : ""
                }${
                  kitchenname ? `, Dapur ${kitchenname.toUpperCase()}` : ""
                }`}</div>
              </div>

              <div
                className={`transform transition-transform ${
                  isDropdownOpen ? "rotate-180" : "rotate-0"
                }`}
              >
                ▼
              </div>
            </div>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div
                ref={dropdownRef} // Attach ref to the dropdown
                className="absolute mt-2 w-40 bg-white shadow-lg rounded-lg z-50"
                style={{ top: "100%", right: 0 }}
              >
                <ul className="text-sm text-gray-700">
                  {canInstall && (
                    <li
                      className="px-4 py-2 hover:bg-gray-100 hover:rounded-lg cursor-pointer"
                      onClick={installPrompt}
                      style={{ lineHeight: "1.5rem", textAlign: "left" }}
                    >
                      Install
                    </li>
                  )}
                </ul>
                <ul className="text-sm text-gray-700">
                  <li
                    className="px-4 py-2 hover:bg-gray-100 hover:rounded-lg cursor-pointer"
                    onClick={handleLogOut}
                    style={{ lineHeight: "1.5rem", textAlign: "left" }}
                  >
                    Log Out
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* Notification Dropdown */}
        {isDropdownNotifOpen && (
          <div
            ref={dropdownRef} // Attach ref to the dropdown
            className="absolute right-0 mt-2 w-80 bg-white border border-gray-300 rounded-[15px] shadow-md z-50"
          >
            <div className="px-4 py-2 border-b">
              <h3 className="text-sm font-semibold">Pemberitahuan</h3>
            </div>
            <ul className="max-h-64 overflow-y-auto">
              {loading ? (
                <li className="px-4 py-8 flex justify-center">
                  {/* Loading Spinner */}
                  <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                </li>
              ) : notifications.length === 0 ? (
                <li className="px-4 py-2 text-center text-gray-500 text-xs">
                  Tidak ada pemberitahuan baru
                </li>
              ) : (
                notifications.map((notification) => (
                  <li
                    key={notification.id}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      // Add your logic for handling notification click (e.g., navigate to `link`)
                      console.log(notification);
                    }}
                  >
                    <h4 className="text-xs font-semibold">
                      {notification.title}
                    </h4>
                    <p className="text-xs text-gray-600">
                      {notification.message}
                    </p>
                    <span className="text-xxs text-gray-500">
                      {new Date(notification.createdat).toLocaleString()}
                    </span>
                  </li>
                ))
              )}
            </ul>
          </div>
        )}
        {/* Main Content */}
        <div className="relative p-4 mt-8">
          <Outlet /> {/* Render the current route’s component here */}
        </div>
      </div>
    </div>
  );
}
